
// Sostituire lo stato sopra con uno di quelli sotto
export const CLOUD_STATUS_OK = 0;
export const CLOUD_STATUS_MAINTENANCE = 1;
